import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractCapitalizeFirstLetter',
  standalone: true
})
export class CapitalizeFirstLetterPipe implements PipeTransform {

  transform(value: string): string {
    if (!value || typeof value !== 'string') {
      return value;
    }

    return value.charAt(0).toUpperCase();
  }

}